import React, { FormEvent, useState } from 'react';

import CollapsableItem from '../../utils/CollapsableItem';
import ActivityEditMobileActions from '../ActivityEditMobileAction';
import ActivityFormField from '../ActivityForm/ActivityFormField';

import ActivityMetaFieldsNote from './ActivityMetafieldsNote';
import { Metafields } from './ActivityMetafields';

type Props = {
  metafields: Metafields;
  onMetaFieldsChange(values: unknown): void;
  onSaveClick(e: FormEvent<EventTarget>): void;
  onResetClick(): void;
  werePropertiesChanged: boolean;
  hasNativeMetafields?: boolean;
  isNotIntegrationEnabled: boolean;
};

const ActivityMobileMetaFields = ({
  metafields,
  onMetaFieldsChange,
  onSaveClick,
  onResetClick,
  werePropertiesChanged,
  hasNativeMetafields,
  isNotIntegrationEnabled,
}: Props) => {
  const [isEditMode, setIsEditMode] = useState(false);

  return (
    <div className='data-box'>
      <h4 className='header'>
        Activity Metafields
        <ActivityEditMobileActions
          isEditMode={isEditMode}
          setIsEditMode={setIsEditMode}
          onSaveClick={onSaveClick}
          onResetClick={onResetClick}
          disabled={werePropertiesChanged}
        />
      </h4>
      {hasNativeMetafields && <ActivityMetaFieldsNote />}
      <CollapsableItem>
        {
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          <ActivityFormField
            label='Popularity'
            name='popularity'
            value={metafields.popularity}
            onMetaFieldsChange={onMetaFieldsChange}
            isMobileView
            isMobileEditMode={isEditMode}
          />
        }
        {!isNotIntegrationEnabled ? (
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          <ActivityFormField
            label='Available-Days'
            name='hours'
            value={metafields.hours}
            onMetaFieldsChange={onMetaFieldsChange}
            isMobileView
            isMobileEditMode={isEditMode}
          />
        ) : null}
        {
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          <ActivityFormField
            label='Cancellation-Policy'
            name='cancellationPolicy'
            value={metafields.cancellationPolicy}
            onMetaFieldsChange={onMetaFieldsChange}
            isMobileView
            isMobileEditMode={isEditMode}
          />
        }
        {
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          <ActivityFormField
            label='Bach-Tip'
            name='bachTip'
            value={metafields.bachTip}
            onMetaFieldsChange={onMetaFieldsChange}
            isMobileView
            isMobileEditMode={isEditMode}
          />
        }
      </CollapsableItem>
    </div>
  );
};

export default ActivityMobileMetaFields;
